import { render, staticRenderFns } from "./RegistrationSuccessful.vue?vue&type=template&id=ef5a5db6&scoped=true"
import script from "./RegistrationSuccessful.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a5db6",
  null
  
)

export default component.exports